import { render, staticRenderFns } from "./CardItem.vue?vue&type=template&id=5dde1ace&scoped=true"
import script from "./CardItem.vue?vue&type=script&lang=js"
export * from "./CardItem.vue?vue&type=script&lang=js"
import style0 from "./CardItem.vue?vue&type=style&index=0&id=5dde1ace&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dde1ace",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5dde1ace')) {
      api.createRecord('5dde1ace', component.options)
    } else {
      api.reload('5dde1ace', component.options)
    }
    module.hot.accept("./CardItem.vue?vue&type=template&id=5dde1ace&scoped=true", function () {
      api.rerender('5dde1ace', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client-view/home/components/CardItem.vue"
export default component.exports